import * as React from "react";
import {
    LifecycleResource,
    PhaseResource,
    EnvironmentResource,
} from "client/resources";
import LifecycleMapInternal from "./LifecycleMapInternal";
import {mapProgressionToStatus} from "utils/MapProgressionToStatus/MapProgressionToStatus";
import MarkdownDescription from "components/MarkdownDescription";

interface Props {
    lifecyclePreview: LifecycleResource;
    environmentsById: {[id: string]: EnvironmentResource};
    className?: string;
    showDescription?: boolean;
}

const LifecycleMap: React.StatelessComponent<Props> = props => {

    const phases: PhaseResource[] = props.lifecyclePreview.Phases
        ? props.lifecyclePreview.Phases
        : [];

    const lifecycleStatus = mapProgressionToStatus();

    return <div>
        {props.showDescription && <MarkdownDescription markup={props.lifecyclePreview.Description} />}
        <LifecycleMapInternal phases={phases}
            environmentsById={props.environmentsById}
            lifecycleStatus={lifecycleStatus}
            className={props.className}
        />
    </div>;
};

export default LifecycleMap;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/library/components/Lifecycle/LifecycleMap/LifecycleMap.tsx